import {
	ServiceContractBusinessModel,
	ServiceContractDto,
	ServiceContractSource,
	ServiceContractStatus,
	ServiceContractType,
} from 'api/v1/data-contracts';
import { ParseKeys, TOptions } from 'i18next';

import { ServiceContract } from './types';

export const serviceContractTypeTranslationMapping: {
	[key: string]: ParseKeys<
		['serviceContracts'],
		TOptions,
		'serviceContracts'
	>;
} = {
	BaseCare: 'serviceContracts:service-type-base',
	ComfortCare: 'serviceContracts:service-type-comfort',
	AdvancedCare: 'serviceContracts:service-type-advanced',
	Other: 'serviceContracts:service-type-other',
	EnhancedCare: 'serviceContracts:service-type-enhanced',
	OptimumCare: 'serviceContracts:service-type-optimum',
};

export const serviceContractBusinessModelTranslationMapping: {
	[key: string]: ParseKeys<
		['serviceContracts'],
		TOptions,
		'serviceContracts'
	>;
} = {
	DealerOwned: 'serviceContracts:business-model-dealer-owned',
	VolvoPentaOwned: 'serviceContracts:business-model-volvo-penta-owned',
};

export const serviceContractSourceTranslationMapping: {
	[key: string]: ParseKeys<
		['serviceContracts'],
		TOptions,
		'serviceContracts'
	>;
} = {
	Connected: 'serviceContracts:source-connected',
	ManuallyAdded: 'serviceContracts:source-manually-added',
};

export const serviceContractStatusTranslationMapping: {
	[key: string]: ParseKeys<
		['serviceContracts'],
		TOptions,
		'serviceContracts'
	>;
} = {
	Ordered: 'serviceContracts:status-ordered',
	Active: 'serviceContracts:status-active',
	Expired: 'serviceContracts:status-expired',
	Paused: 'serviceContracts:status-paused',
	Terminated: 'serviceContracts:status-terminated',
	Deleted: 'serviceContracts:status-deleted',
};

export const mapServiceContractDtoToServiceContract = ({
	id,
	unitPublicId,
	status,
	startDate,
	endDate,
	startHour,
	endMaxHour,
	type,
	businessModel,
	source,
	businessPartner,
	connectivityIncluded,
	preventiveRepair,
	validatedByPenta,
	description,
}: ServiceContractDto): ServiceContract => ({
	id: id ?? undefined,
	unitPublicId: unitPublicId ?? undefined,
	status,
	startDate: new Date(startDate),
	endDate: new Date(endDate),
	startHour: startHour ?? undefined,
	endMaxHour: endMaxHour ?? undefined,
	serviceType: type,
	businessModel: businessModel,
	source,
	responsibleBusinessPartner: businessPartner ?? undefined,
	connectivityIncluded,
	preventiveRepair,
	validatedByVolvoPenta: validatedByPenta,
	description: description ?? undefined,
});

export const mapServiceContractToServiceContractDto = ({
	id,
	unitPublicId,
	status,
	startDate,
	endDate,
	startHour,
	endMaxHour,
	serviceType,
	businessModel,
	source,
	responsibleBusinessPartner,
	connectivityIncluded,
	preventiveRepair,
	validatedByVolvoPenta,
	description,
}: ServiceContract): ServiceContractDto => ({
	id: id ?? null,
	unitPublicId: unitPublicId ?? null,
	status: (status as ServiceContractStatus) ?? null,
	startDate,
	endDate: endDate ?? new Date(),
	startHour: startHour ?? null,
	endMaxHour: endMaxHour ?? null,
	type: serviceType as ServiceContractType,
	businessModel: businessModel as ServiceContractBusinessModel,
	source: (source as ServiceContractSource) ?? null,
	businessPartner: responsibleBusinessPartner ?? null,
	connectivityIncluded,
	preventiveRepair,
	validatedByPenta: validatedByVolvoPenta,
	description: description ?? null,
	individualServices: null,
	servicePlan: null,
	terminationDate: null,
});
